import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { seedFromMastery } from "./lib/study";
import { startSync } from "./lib/sync";
import "./styles/index.css";

const root = document.getElementById("root");
if (!root) throw new Error("Root element #root not found");

// Words labelled before the scheduler existed have no review date yet. Give
// them one before the first render so the due counts are right immediately.
// Stays synchronous and offline: the app must be usable before the network is.
seedFromMastery();

// Signed out, offline, or with no backend at all this does nothing. Started
// here rather than from an effect so StrictMode can't run it twice.
startSync();

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
